module.exports = __webpack_public_path__ + "static/h1-31e79f92c01d604f8fb30bf9c221b272.png";